///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, Input, OnInit } from '@angular/core';
import { GtthHistoryService } from '../../../../logical-topology/engine/history-service';
import { NodeFeature } from '../../../../logical-topology/entities/node/node-feature';
import { GtthNodeFeatureDtoModel } from '../../../../../services/project-socket/dto/gtth-node-feature-dto.model';
import { isDefined } from '@siklu/sui-lib/utils';
import { PotentiallyProblematicBuDeviceDTO } from '../../../../../generated/shared-types.model';

class ProblematicSector {
    sectorInDeviceId: number;
    sectorInDeviceViewValue: string;
    neighbourNames: string;
}

@Component({
    selector: 'winde-problematic-bu-component',
    templateUrl: './problematic-bu.component.html',
    styleUrls: ['problematic-bu.component.scss'],
    standalone: false
})
export class ProblematicBuComponent implements OnInit {
    @Input() problematicBuData: PotentiallyProblematicBuDeviceDTO;

    public buLocation: NodeFeature;
    public sectorData: ProblematicSector[] = [];
    public blockedByPole: string;

    constructor(private readonly historyService: GtthHistoryService) {}

    ngOnInit(): void {
        const nodeFeatureDto = GtthNodeFeatureDtoModel.fromData(this.problematicBuData.name);
        this.buLocation = this.historyService.logicalTopology.getStationByName(nodeFeatureDto.getName());

        for (let i = 0; i < 4; i++) {
            if (isDefined(this.problematicBuData.occupiedSectors[i])) {
                const problematicSector = {
                    sectorInDeviceId: i,
                    sectorInDeviceViewValue: i + 1 + '',
                    neighbourNames: this.problematicBuData.occupiedSectors[i]
                        .map((neighbour) => GtthNodeFeatureDtoModel.fromData(neighbour).getName())
                        .join(', ')
                } as ProblematicSector;
                this.sectorData.push(problematicSector);
            }
        }

        this.blockedByPole = this.problematicBuData.blockedByPole
            .map((neighbour) => GtthNodeFeatureDtoModel.fromData(neighbour).getName())
            .join(', ');
    }
}
